import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_serverEndpoint;

const buildUrl = (controller, action, competitionId, id) => {
  const base = `${API_BASE_URL}/${controller}/${action}?competitionId=${encodeURIComponent(competitionId)}`;
  if (id) {
    return `${base}&id=${encodeURIComponent(id)}`;
  }
  return base;
};

const withAuthHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
});

const createEntityClient = (controller) => ({
  get: async (competitionId, id, token) => {
    const url = buildUrl(controller, 'Get', competitionId, id);
    const response = await axios.get(url, withAuthHeaders(token));
    return response.data;
  },
  insert: async (competitionId, payload, token) => {
    const url = buildUrl(controller, 'Insert', competitionId);
    const response = await axios.post(url, payload, withAuthHeaders(token));
    return response.data;
  },
  update: async (competitionId, id, payload, token) => {
    const url = buildUrl(controller, 'Update', competitionId, id);
    const response = await axios.put(url, payload, withAuthHeaders(token));
    return response.data;
  },
  remove: async (competitionId, id, token) => {
    const url = buildUrl(controller, 'Delete', competitionId, id);
    await axios.delete(url, withAuthHeaders(token));
    return { id };
  },
  reorder: async (competitionId, items, token) => {
    const url = `${API_BASE_URL}/${controller}/Reorder?competitionId=${encodeURIComponent(competitionId)}`;
    const response = await axios.post(url, items, withAuthHeaders(token));
    return response.data;
  }
});

const competitionEntityApi = {
  competitions: createEntityClient('Competitions'),
  sessions: createEntityClient('Sessions'),
  events: createEntityClient('Events'),
  heats: createEntityClient('Heats'),
  athletes: createEntityClient('Athletes'),
  clubs: createEntityClient('Clubs'),
  coaches: createEntityClient('Coaches'),
  officials: createEntityClient('Officials'),
  competitionPermissions: createEntityClient('CompetitionPermissions'),
  rankinggroups: createEntityClient('Rankinggroups'),
  rankings: createEntityClient('Rankings'),
  recordlists: createEntityClient('Recordlists'),
  records: createEntityClient('Records'),
  results: createEntityClient('Results'),
  timestandards: createEntityClient('Timestandards')
};

export default competitionEntityApi;
